module.exports = __webpack_public_path__ + "img/news4.53524ced.png";